<template>
  <div class="img col-sm-12">
    <img src="../assets/IMG/mockup_web.webp" alt="Mockup" />

    <div class="tx-text text-center">
      <h1 class="headline">
        <span class="the-light">THE</span>
        <span class="my-card-bold">MY CARD</span>
        <span class="my-word-extra"> WORD</span>
      </h1>
    </div>
  </div>
</template>

<script>
export default { name: "Everybody" };
</script>

<style scoped>
@font-face {
  font-family: "TT Chocolates Trial";
  src: url("@/assets/fonts/TT Chocolates Trial Light.otf") format("opentype");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "TT Chocolates Trial";
  src: url("@/assets/fonts/TT Chocolates Trial Bold.otf") format("opentype");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "TT Chocolates Trial";
  src: url("@/assets/fonts/TT Chocolates Trial ExtraBold.otf") format("opentype");
  font-weight: 800;
  font-style: normal;
  font-display: swap;
}

.img {
  position: relative;
  width: 100%;
  display: block;
  background-color: #050505;
  margin: 0;
  padding: 0;
}

.img::after {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(
    circle at 50% 45%,
    rgba(0, 0, 0, 0.36) 0%,
    rgba(0, 0, 0, 0.16) 55%,
    rgba(0, 0, 0, 0.06) 100%
  );
  pointer-events: none;
  z-index: 1;
}

.img img {
  width: 100%;
  height: auto;
  display: block;
}

.tx-text {
  position: absolute;
  z-index: 2;
  left: 50%;
  top: 52%;
  transform: translate(-50%, -50%);
  width: min(1200px, 95%);
  text-align: center;
}

.headline {
  margin: 0;
  line-height: 0.82;
  letter-spacing: 0.02em;
  color: #fff;
  text-shadow: 0 14px 40px rgba(0, 0, 0, 0.55);
  animation: heroIn 650ms ease both;
}

.the-light,
.my-card-bold {
  display: inline-block;
  vertical-align: baseline;
  white-space: nowrap;
}

.the-light {
  font-family: "TT Chocolates Trial", sans-serif;
  font-weight: 300;
  font-size: 110px;
  opacity: 0.98;
  margin-right: clamp(10px, 1.6vw, 18px);
  letter-spacing: 0.10em;
}

.my-card-bold {
  font-family: "TT Chocolates Trial", sans-serif;
  font-weight: 700;
  font-size: clamp(56px, 6.8vw, 170px);
  letter-spacing: 0.14em;
}

.my-word-extra {
  display: block;
  margin-top: clamp(8px, 1.4vw, 18px);
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  transform: translateX(clamp(5px, 0.8vw, 12px));
  font-family: "TT Chocolates Trial", sans-serif;
  font-weight: 800;
  letter-spacing: 0.16em;
  font-size: 215px;
}

@media (hover: hover) {
  .headline:hover .my-word-extra {
    transform: translateY(-2px);
    transition: transform 180ms ease;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .tx-text {
    top: 54%;
    width: min(980px, 94%);
  }

  .the-light {
    font-size: clamp(42px, 5.3vw, 110px);
    letter-spacing: 0.08em;
  }

  .my-card-bold {
    font-size: clamp(54px, 6.6vw, 140px);
    letter-spacing: 0.12em;
  }

  .my-word-extra {
    font-size: clamp(90px, 13.5vw, 240px);
    letter-spacing: 0.13em;
  }
}

@media (max-width: 767px) {
  .tx-text {
    top: 56%;
    width: 96%;
  }

  .headline {
    line-height: 0.86;
  }

  .the-light {
    font-size: clamp(40px, 11vw, 80px);
    letter-spacing: 0.06em;
    margin-right: 10px;
  }

  .my-card-bold {
    font-size: clamp(48px, 13vw, 100px);
    letter-spacing: 0.08em;
  }

  .my-word-extra {
    font-size: clamp(85px, 22vw, 180px);
    letter-spacing: 0.10em;
    margin-top: 10px;
  }
}

@media (max-width: 420px) {
  .tx-text { top: 57%; }

  .the-light { font-size: clamp(30px, 9.2vw, 54px); }
  .my-card-bold { font-size: clamp(36px, 10.8vw, 68px); }
  .my-word-extra { font-size: clamp(64px, 19vw, 130px); }
}

@keyframes heroIn {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.985);
    filter: blur(1px);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
    filter: blur(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .headline { animation: none; }
}
</style>
